"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets_1) {
        var views;
        (function (views) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.datasetsIndex = appn.emptyString;
                        this.createUrl = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable;
                function init(args) {
                    _initArgs = args;
                    appn.folderFilter.init(_initArgs.datasetsIndex);
                    createDataTable();
                    addEvents();
                }
                index_1.init = init;
                function addEvents() {
                    $('#create').off('click').on('click', function () {
                        const folderId = appn.folderFilter.selectedFolderId;
                        appn.iframe.openModal({ url: folderId ? `${_initArgs.createUrl}?folderId=${folderId}` : _initArgs.createUrl });
                    });
                    $('#confirmBulkDeleteBtn').off('click').on('click', function () {
                        const formElement = document.getElementById('appnFormManageDatasets');
                        if (formElement) {
                            formElement.submit();
                        }
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'Datasets/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', ''), { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value });
                        },
                        aaSorting: [[1, 'asc']],
                        autoWidth: false,
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '30%' },
                            { bSortable: true, sWidth: '17%' },
                            { bSortable: true, sWidth: '10%' },
                            { bSortable: true, sWidth: '15%' }
                        ],
                        fnInitComplete: function () {
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#organiseBtn').click(function () {
                                appn.folderFilter.showDialog($(this), 'Datasets');
                            });
                            $('#manageBtn').on('click', function (e) {
                                e.preventDefault();
                                if ($(this).css('opacity') === '1') {
                                    const $selectedItems = $('.selectRow:checked');
                                    let datasets = appn.emptyString;
                                    $selectedItems.each(function (index, selected) {
                                        const datasetId = $(selected).attr('id');
                                        datasets += `${datasetId},`;
                                    });
                                    $('#datasetsToManage').val(datasets);
                                    $('#manageDatasetsDialog').modal('show');
                                }
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where Dataset <b>Title, External Id or Status</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(index = views.index || (views.index = {}));
        })(views = datasets_1.views || (datasets_1.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
